import { UserInfo } from "./UserInfo";

const localStorageKeys = {
    accessToken: 'accessToken',
    payload: 'payload',
    userPhoto: 'userPhoto',
    configUnit: 'configUnit',
    module: 'module',
    user: 'user',
};

const OAuthProvider = {
    isLoggedIn(): boolean {
        return !!localStorage.getItem(localStorageKeys.accessToken);
    },
    
    setSession(user: UserInfo | undefined): void {
        if (!user) throw new Error('User session cannot be null.');
        localStorage.setItem(localStorageKeys.accessToken, user.token);
        localStorage.setItem(localStorageKeys.payload, JSON.stringify(user));
    },
    
    getSession(): UserInfo | null {
        const dataJson = localStorage.getItem(localStorageKeys.user);
        return dataJson ? (JSON.parse(dataJson) as UserInfo) : null;
    },
    
    getAccessToken(): string | null {
        return localStorage.getItem(localStorageKeys.accessToken);
    },
    
    setAvatar(userPhoto: string): void {
        if (userPhoto && !userPhoto.startsWith('data:image')) {
            userPhoto = `data:image/jpeg;base64,${userPhoto}`;
        }
        localStorage.setItem(localStorageKeys.userPhoto, userPhoto);
    },
    
    getAvatar(): string | null {
        return localStorage.getItem(localStorageKeys.userPhoto);
    },
    
    clear(): void {
        Object.values(localStorageKeys).forEach(key => localStorage.removeItem(key));
    },
    
    
    setConfigUnit(key: string, data: any): void {
        localStorage.setItem(`${localStorageKeys.configUnit}.${key}`, JSON.stringify(data));
    },
    
    getConfigUnit(key: string): any {
        const dataJson = localStorage.getItem(`${localStorageKeys.configUnit}.${key}`);
        return dataJson ? JSON.parse(dataJson) : null;
    }
};

export default OAuthProvider;
